import React from 'react';
import '../styles/Contact.css';

const Contact = () => (
  <section id="contact" className="contact-section">
    <h2>Contact</h2>
    <p>Got a cool idea or just want to say hey? Reach out!</p>
    <ul>
      <li>Email: <a href="mailto:whagedorn@wisc.edu">whagedorn@wisc.edu</a></li>
      <li>GitHub: <a href="https://github.com/will-hagedorn">GitHub</a></li>
      <li>LinkedIn: <a href="https://www.linkedin.com/in/will-hagedorn/">LinkedIn</a></li>
    </ul>
  </section>
);

export default Contact;
